import React from 'react'
import {Button, ButtonGroup} from "react-bootstrap";
import "./DateNavigation.css";
import PrimeDateRangeInput from "../date-input/PrimeDateRangeInput";
import DateUtil from "../../utils/DateUtil";
import moment from "moment";

export class DateNavigation extends React.Component {

    constructor(props) {
        super(props);

        this.state = {date: this.props.date || DateUtil.today()};
    }

    componentDidUpdate(prevProps, prevState, snapshot) {
        if (prevProps.date !== this.props.date) {
            this.setState({date: this.props.date});
        }
    }

    setDateStateAndNotifyChange = (date) => {
        this.setState({date}, this.props.onDateChange(date))
    }

    render() {
        const date = this.state.date;
        const activeClassName = "DateNavigationActiveButton";
        const classBack = DateUtil.isYesterday(date) ? activeClassName : "";
        const classToday = DateUtil.isToday(date) ? activeClassName : "";
        const classNext = DateUtil.isTomorrow(date) ? activeClassName : "";

        return (
            <>
                <ButtonGroup aria-label="Date Buttons" className="DateNavigationButtonGroup">
                    <Button variant="outline-secondary"
                            className={classBack}
                            onClick={() => {
                                this.setDateStateAndNotifyChange(DateUtil.addDays(this.state.date, -1))
                            }}>
                        Back
                    </Button>
                    <Button variant="outline-secondary"
                            className={classToday}
                            onClick={() => {
                                this.setDateStateAndNotifyChange(DateUtil.today())
                            }}>
                        Today
                    </Button>
                    <Button variant="outline-secondary"
                            className={classNext}
                            onClick={() => {
                                this.setDateStateAndNotifyChange(DateUtil.addDays(this.state.date, 1))
                            }}>
                        Next
                    </Button>
                </ButtonGroup>

                <span className="DateNavigationButtonGroup">
                    <PrimeDateRangeInput single
                                         value={moment(date).toDate()}
                                         onChange={this.setDateStateAndNotifyChange}/>
                </span>
            </>
        );
    }
}
